import React, { lazy, Suspense } from 'react'
import { Routes, Route, useLocation, Outlet } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { CircularProgress, Box } from '@mui/material'

// Layouts
import HomeLayout from './components/HomeLayout'
import AppLayout from './components/AppLayout'

// Eagerly load the home page for fast first paint
import Home from './pages/home'
import { AuthProvider } from './contexts/AuthContext'

// Lazy load all other pages
const Booking = lazy(() => import('./pages/Booking'))
const BookingDetails = lazy(() => import('./pages/BookingDetails'))
const Login = lazy(() => import('./pages/Login'))
const Signup = lazy(() => import('./pages/Signup'))
const ForgotPassword = lazy(() => import('./pages/Login/ForgotPassword'))
const NotFound = lazy(() => import('./pages/notfound'))
const Locations = lazy(() => import('./pages/locations'))
const TermsOfService = lazy(() => import('./pages/TermsOfService'))
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'))
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'))
const Profile = lazy(() => import('./components/Profile'))
const AboutPage = lazy(() => import('./pages/About'))
const HowItWorks = lazy(() => import('./pages/HowItWorks'))

const PageLoader = () => (
	<Box
		display="flex"
		justifyContent="center"
		alignItems="center"
		minHeight="60vh"
	>
		<CircularProgress />
	</Box>
)

const App = () => {
	const location = useLocation()

	return (
		<AnimatePresence mode="wait">
			<AuthProvider>
				<Suspense fallback={<PageLoader />}>
					<Routes location={location} key={location.key}>
						<Route
							path="/"
							element={
								<HomeLayout>
									<Home />
								</HomeLayout>
							}
						/>

						<Route
							path="/app"
							element={
								<AppLayout>
									<Outlet />
								</AppLayout>
							}
						>
							<Route path="booking" element={<Booking />} />
							<Route path="booking/details" element={<BookingDetails />} />
							<Route path="locations" element={<Locations />} />
						</Route>

						<Route path="/app/login" element={<Login />} />
						<Route path="/app/signup" element={<Signup />} />
						<Route path="/app/forgot-password" element={<ForgotPassword />} />

						{/* <Route path="/app/otp" element={<OTP />} /> */}
						<Route path="/app/profile" element={<Profile />} />

						<Route
							path="/terms"
							element={
								<AppLayout>
									<TermsOfService />
								</AppLayout>
							}
						/>
						<Route
							path="/privacy"
							element={
								<AppLayout>
									<PrivacyPolicy />
								</AppLayout>
							}
						/>
						<Route
							path="/cookies"
							element={
								<AppLayout>
									<CookiePolicy />
								</AppLayout>
							}
						/>

						<Route
							path="/about"
							element={
								<AppLayout>
									<AboutPage />
								</AppLayout>
							}
						/>

						<Route
							path="/how-it-works"
							element={
								<AppLayout>
									<HowItWorks />
								</AppLayout>
							}
						/>
						{/* contact us  */}
						{/* <Route
            path="/contact"
            element={
              <AppLayout>
                <ContactUs />
              </AppLayout>
            }
          /> */}

						{/* 404 route */}
						<Route path="*" element={<NotFound />} />
					</Routes>
				</Suspense>
			</AuthProvider>
		</AnimatePresence>
	)
}

export default App
